import service from '@/services/cajas/sesion'

const getDefaultState = () => ({
  sesion: {
    caja: {},
    user: {
      _id: null,
      fullname: null
    },
    status: 'ABIERTA',
    state: true,
    montoInicial: 0,
    cuentaContable: null
  },
  contador: [],
  cajaInvalida: {
    state: false
  },
  checkLimits: {
    limiteInferior: 0,
    limiteSuperior: 0
  },
  status: [
    { value: 'ABIERTA', text: 'success' },
    {
      value: 'CERRADA',
      text: 'warning'
    },
    {
      value: 'FINALIZADA',
      text: 'danger'
    }
  ],
  saldo: 0,
  activas: [], //cajas abiertas de un usuario logueado.
  list: [],
  pageInfo: {},
  totalRegistros: 0,
  currentRow: null,
  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  SET_CONTADOR: (state, arr) => {
    state.contador = arr
  },
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.sesion = { ...getDefaultState().sesion }),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_LIST: (state, obj) => {
    state.list = [...new Set([...state.list.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.pageInfo = obj.pageInfo
  },
  // UPDATE_LIST: (state, obj) => {
  //   const nObj = state.list.find(e => e._id === obj._id)
  //   if (!nObj) state.list = [obj, ...state.list]
  //   else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))
  //   state.saved = true
  // },
  SET_SESION: (state, obj) => {
    state.sesion = obj
  },
  RESET_SALDO: (state, obj) => {
    state.cajaSesion = null
  }

  // DELETE_LIST: (state, { obj }) => {
  //   state.list = state.list.filter(e => e._id !== obj._id)
  // },
  // SAVE_CHANGES: (state, obj) => {
  //   state.sesion = obj
  //   state.saved = false
  // }
}

export const actions = {
  resetList: ({ state }) => {
    state.list = []
    state.pageInfo = {}
  },
  resetSesion: ({ commit }) => commit('RESET'),
  create: async ({ commit, rootGetters, state, dispatch }) => {
    // la cuenta contable es asignada por el backend.
    const { cuentaContable, userSession, createdAt, updatedAt, ...current } = state.sesion
    current.montoInicial = Number(current.montoInicial)

    return service
      .create({
        ...current,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        // if (state.list.length)
        // commit('UPDATE_LIST', {
        //   ...current,
        //   _id: result._id,
        //   completedAt: result.completedAt,
        //   createdAt: result.createdAt,
        //   saldo: current.montoInicial
        // })

        // actualiza la lista de cajas.
        dispatch(
          'cajas/cajaStore/readAllByEmisor',
          {
            restart: true,
            limit: 15
          },
          { root: true }
        )

        state.sesion._id = result._id

        return result
      })
  },
  readTotal: async ({ state, rootGetters }) =>
    service.readTotal(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      state.totalRegistros = response
    }),

  readBySearchString: async ({ state, rootGetters }, { searchString }) =>
    service.readBySearchString(rootGetters['facturacion/emisorStore/get_Id'], searchString),

  // readByStatus: async ({ commit, rootGetters }, { status, caja }) =>
  //   service.readByStatus(rootGetters['facturacion/emisorStore/get_Id'], caja, status).then(response => {
  //     commit('SET_ONLINE_LIST', response)
  //     return response
  //   }),

  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetList')

    // manufactura, reventa, consumible: tipoProducto === '02' - '03' - '04'
    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit, filter).then(response => {
      return commit('SET_LIST', response)
    })
  },

  readById: async ({ commit }, { _id }) =>
    service.readById(_id).then(response => {
      commit('SET_SESION', response)
      return response
    }),

  readByUser: async ({ state }, user) =>
    service.readByUser(user).then(response => {
      state.activas = response
      return response
    }),

  cierreCaja: async ({ rootGetters, state }, { caja, sesion, nombre, montosTotales, balance, movimiento, cuentaContable }) => {
    movimiento.montoEgreso = Number(movimiento.montoEgreso)

    return service
      .cierreCaja(
        caja,
        sesion,
        nombre,
        montosTotales,
        balance,
        {
          ...movimiento,
          _idFactura: '000000000000000000000000',
          cuentaContable,
          emisor: {
            _id: await rootGetters['facturacion/emisorStore/get_Id']
          }
        },
        state.contador
      )
      .then(() => {
        state.contador = []
      })
  },

  finCaja: async ({ rootGetters }, { caja, sesion, movimiento }) => {
    movimiento.montoEgreso = Number(movimiento.montoEgreso)
    return service.finCaja(
      caja,
      sesion,

      {
        ...movimiento,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      }
    )
  },

  readSaldo: async ({ state }, _id) => {
    return service.readSaldo(_id).then(response => {
      state.saldo = response

      return response
    })
  }

  // delete: ({ commit }, { items }) =>
  //   service.delete(items).then(result => {
  //     result.forEach(i => {
  //       if (i.state) commit('DELETE_LIST', { obj: i })
  //     })
  //     return result
  //   }),
  // saveChanges: ({ commit }, input) => commit('SAVE_CHANGES', input)
}

export const getters = {
  sesionStatus: state => value => {
    const status = state.status.find(e => e.value === value)

    return status?.text || 'info'
  }
}
